import React from 'react';

interface Props {
  step: string;            // e.g. "Step 1"
  title: string;           // e.g. "現状診断"
}

const StepBar: React.FC<Props> = ({ step, title }) => (
  <div className="w-full bg-slate-100 py-2 my-6">
    <div className="flex items-center gap-4 px-6">
      <span className="text-[11px] font-semibold tracking-[0.12em] text-slate-400 uppercase">
        {step}
      </span>
      <div className="w-[2px] h-4 bg-slate-900" />
      <span className="text-sm font-semibold text-slate-900">{title}</span>
    </div>
  </div>
);

export default StepBar;
